import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import WebHome from "../containers/WebHome/WebHome";
import WebProfile from "../containers/WebProfile/WebProfile";
import Rooms from "../containers/Rooms";
import WebMyJourneyScreen from "../containers/AppJourneyPage";
import WebStoryScreen from "../containers/WebStoryScreen";
import WebStoryBreakScreen from "../containers/WebStoryScreen/Components/WebStoryBreakScreen";
import ChatWithTrooScreen from "../containers/ChatWithTrooScreen";

function WebStoryScreenRoute() {
  const { state } = useLocation();
  return (
    <WebStoryScreen
      routeParams={{
        storyId: state?.storyId,
        isDocumentId: state?.isDocumentId,
      }}
    />
  );
}

function WebAppRouter() {
  return (
    <Routes>
      <Route
      // element={<WithHeader />}
      >
        <Route index element={<Navigate to="RoomsTab" replace />} />
        <Route path="home" element={<WebHome />} />
        <Route path="profile" element={<WebProfile />} />
        <Route path="RoomsTab" element={<Rooms />} />
        <Route path="rooms" element={<Rooms />} />
        <Route path="appJourneyPage" element={<WebMyJourneyScreen />} />
        <Route path="WebStoryScreen" element={<WebStoryScreenRoute />} />
        <Route path="WebStoryBreakScreen" element={<WebStoryBreakScreen />} />
        <Route path="chatWithTroo" element={<ChatWithTrooScreen />} />
        <Route path="*" element={<Navigate to="/web/rooms" replace />} />
      </Route>
    </Routes>
  );
}

export default WebAppRouter;
